import type {DungeonLight} from "@/dungeons/model/DungeonGeometry.ts";

export type LightPreset = DungeonLight["preset"];
export const DEFAULT_LIGHT_COLOR_STRENGTH = 0.5;
export type LightSettings = Pick<DungeonLight, "rangeMeters" | "intensity" | "color"> & {colorStrength: number; animation: null};

export const LIGHT_PRESETS: Record<Exclude<LightPreset, "CUSTOM">, LightSettings> = {
    CANDLE: {rangeMeters: 6, intensity: 0.40, colorStrength: 0.2, color: "#ffb45a", animation: null},
    TORCH: {rangeMeters: 18, intensity: 0.60, colorStrength: 0.3, color: "#ffad55", animation: null},
    CAMPFIRE: {rangeMeters: 24, intensity: 0.85, colorStrength: 0.6, color: "#ff9147", animation: null},
};

export const LIGHT_PRESET_LABELS: Record<LightPreset, string> = {
    CANDLE: "Kerze", TORCH: "Fackel", CAMPFIRE: "Lagerfeuer",
    CUSTOM: "Benutzerdefiniert",
};
